import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import PageScrollTop from "./components/pageToTop/PageScrollTop";

// Pages import Here
import MoftahSolutions from "./pages/MoftahSolutions";
import AboutUs from "./pages/AboutUs";
import NoorPrivacyPolicy from "./pages/NoorPrivacyPolicy";

// Elements import Here
import Contact from "./pages/Contact";

// Import Css Here
import "./assets/scss/style.scss";

const App = () => {
  return (
    <Router>
      <PageScrollTop>
        <Routes>
          <Route
            path={`${process.env.PUBLIC_URL + "/"}`}
            exact
            element={<MoftahSolutions />}
          />

          <Route
            path={`${process.env.PUBLIC_URL + "/contact"}`}
            exact
            element={<Contact />}
          />

          <Route
            path={`${process.env.PUBLIC_URL + "/about-us"}`}
            exact
            element={<AboutUs />}
          />

          <Route
            path={`${process.env.PUBLIC_URL + "/noor-privacy-policy"}`}
            exact
            element={<NoorPrivacyPolicy />}
          />
          
          <Route 
            path="*"
            element={<Navigate replace to="/" />} 
          />
        </Routes>
      </PageScrollTop>
    </Router>
  );
};

export default App;
